import { render, staticRenderFns } from "./SuccessSubmitForm19.vue?vue&type=template&id=e450b54e&scoped=true"
import script from "./SuccessSubmitForm19.vue?vue&type=script&lang=ts"
export * from "./SuccessSubmitForm19.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e450b54e",
  null
  
)

export default component.exports